module.exports = "<div class=\"js-branch-collection unnamed-item\"></div>";